<template>
  <div :class="{['p-question__'+tagPosition]:true}">
    <ul class="tagList">
      <li v-for="(label, index) in tagLabel" :key="index" v-text="label" class="tagLabel"></li>
      <li v-if="tagCorrect" class="tagCorrect" v-text="tagCorrect ? '正解済' : ''"></li>
      <li v-if="!isTagReviewRequired && !explanationPage" class="tagReview"><a v-text="!isTagReviewRequired ? '要復習問題': ''"></a></li>
      <li v-if="explanationPage" :class="[isTagReviewRequired ? 'tagReviewLink': 'tagReview']"
          @click="emit('click')" name="S3-9-review-tag-btn"><a class="tagCursor" v-text="isTagReviewRequired ? '要復習にする': '要復習問題'"></a></li>
    </ul>
    <slot name="prevButton"></slot>
  </div>
</template>

<script setup lang="ts">
  withDefaults(
    defineProps<{
      tagPosition?: string; // 問題が縦か横かによってタグの位置が変わる
      tagLabel: Array<any> // 小門ラベル
      tagCorrect?: boolean // 一度以上正解したことがある場合
      explanationPage?: boolean // S3-9問題画面かどうかフラグ
      isTagReviewRequired?: boolean // S3-9問題画面で要復習タグ付与したかどうかフラグ
    }>(),
    {
      tagPosition: "",
      tagCorrect: false,
      explanationPage: false,
      isTagReviewRequired: false,
    }
  );
  const emit = defineEmits<{
    (e: 'click'): void,
  }>()
</script>
